<div class="entry_values">
  <div class="entry"  *ngFor="let assetLocation of assetLocationArrayForm.get('AssetLocations')['controls']; index as i"
  (click)="onEdit(assetLocation.value, i)"
  style="cursor: pointer;"
  >
    <div class="other_info">
      <p class="no_index">{{i + 1}}.</p>
      <p class="purpose">
        <span>State: </span>
        <span>{{getStateName(assetLocation?.value.StateId)}}</span>
      </p>

      <p class="net_area">
        <span>LGA: </span>
        <span>{{getLgaName(assetLocation?.value.LgaId)}}</span>
      </p>

      <p class="net_area">
        <span>Community: </span>
        <span>{{getCommunityName(assetLocation?.value.CommunityId)}}</span>
      </p>

      <p class="net_area">
        <span>Division: </span>
        <span>{{getDivisionName(assetLocation?.value.DivisionId)}}</span>
      </p>

      <p class="net_area">
        <span>Asset Location Address: </span>
        <span>{{assetLocation?.value.AssetLocationAddress}}</span>
      </p>
      <p class="info" (click)="$event.stopImmediatePropagation()">
        <i class="ti-trash" (click)="onDelete(assetLocation.value, i)"></i>
      </p>
    </div>
  </div>
  <!-- <pre>{{assetLocations | json}}</pre> -->
  </div>
